import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { makeStyles } from '@material-ui/core';
import { NoDataItem } from '~/modules/common/components';

const useStyles = makeStyles(theme => ({
  root: {
    margin: 0
  }
}));

const NoAttachments = ({ multiple = true, messageId }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <NoDataItem dataQeId="NoFileAdded">
        <FormattedMessage
          id={messageId || 'attachments.noAttachments'}
          values={{ multiple }}
        />
      </NoDataItem>
    </div>
  );
};

NoAttachments.propTypes = {
  multiple: PropTypes.bool,
  messageId: PropTypes.string
};

export default NoAttachments;
